import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ['title', 'legendPosition'],
  data: () => ({
    options: {
      responsive: true,
      title: {
        display: false,
        text: '',
        fontColor: '#00095b',
        fontSize: 18,
        fontFamily:'FordAntenna-Regular'
      },
      legend: {
        position: 'right',
        labels: {
          fontColor: '#00095b',
          defaultFontSize: 12,
          defaultFontFamily:'FordAntenna-Regular'
        },
        onHover: function(e) {
          e.target.style.cursor = 'pointer';
        }
      },
      hover: {
        onHover: function(e) {
          var point = this.getElementAtEvent(e);
          if (point.length) e.target.style.cursor = 'pointer';
          else e.target.style.cursor = 'default';
        }
      },
      scales: {
        xAxes: [{
          stacked: true, // stacks bars
          fontColor: '#00095b',
          fontSize: 18,
          fontFamily:'FordAntenna-Regular',
          maxBarThickness: 50,

        }],
        yAxes: [{
          stacked: true, // // stacks bars
        }]
      },
      tooltips: {
        backgroundColor: 'white',
        bodyFontColor: '#00095b',
        bodyFontFamily:'FordAntenna-Regular',
        bodyFontSize: 12,
        borderWidth: '1',
        borderColor: '#6E6E6E',
        // mode: 'dataset',
        displayColors: false,
        callbacks: {
          label: function(tooltipItem, data) {
            const corporation = data.datasets[tooltipItem.datasetIndex].label;
            const valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            let total = 0;
            for (let i = 0; i < data.datasets.length; i++)
              total += data.datasets[i].data[tooltipItem.index];
            if (tooltipItem.datasetIndex != data.datasets.length - 1) {
              // return corporation + " : $" + valor.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
              // return [corporation + " : $" + valor.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'), "Total : $" + total.toFixed(2)];
              return [corporation + " : $" + valor.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0  }), "Total : $" + total.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0  })];
            } else {
              // return [corporation + " : $" + valor.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'), "Total : $" + total];
              // return [corporation + " : $" + valor.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'), "Total : $" + total.toFixed(2)];
              return [corporation + " : $" + valor.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0  }), "Total : $" + total.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0  })];
            }
          }
        }
      },

    },
    // options: {
    //   responsive: true,
    //   legend: {
    //     position: 'bottom'
    //   },
    //   title: {
    //     display: true,
    //     position: 'top',
    //   },
    //   scales: {
    //     x: {
    //       stacked: true,
    //     },
    //     y: {
    //       stacked: true,
    //       suggestedMin: 0,
    //       suggestedMax: 50000
    //     },
    //     yAxes: {
    //       beginAtZero: true,
    //       ticks: {
    //         stepSize: 10000
    //       }
    //     }
    //   }
    // }
  }),

  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    // this.options.title.text = this.title;
    this.options.legend.position = this.legendPosition;


    this.renderChart(this.chartData, this.options)
  }
}
